import { render, staticRenderFns } from "./AccountSetPassword.vue?vue&type=template&id=9c247c20&"
import script from "./AccountSetPassword.vue?vue&type=script&lang=js&"
export * from "./AccountSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports